var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50019 24.0001H19.622V7.95239L12.6782 0.851563L1.82608 0.851562L1.01562 2.56861V22.6418L1.50019 24.0001Z",
    fill: "#F9FCEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15 0H12.75L19.95 7.2C20.1568 7.2 20.344 7.28366 20.4796 7.41897C20.5931 7.53216 20.6705 7.68149 20.6932 7.84823L20.6932 7.84949C20.6977 7.88262 20.7 7.91619 20.7 7.95V22.35C20.7 24.0897 19.2897 25.5 17.55 25.5H3.15C1.4103 25.5 0 24.0897 0 22.35V3.15C0 1.4103 1.4103 0 3.15 0ZM12.75 8.7H19.2V22.35C19.2 23.2613 18.4613 24 17.55 24H3.15C2.23873 24 1.5 23.2613 1.5 22.35V3.15C1.5 2.23873 2.23873 1.5 3.15 1.5H12V7.95L12.0068 8.05177C12.0565 8.41785 12.3703 8.7 12.75 8.7ZM15.8969 13.9492C15.8969 13.535 15.5611 13.1992 15.1469 13.1992H5.54688L5.4451 13.2061C5.07903 13.2557 4.79688 13.5695 4.79688 13.9492C4.79688 14.3634 5.13266 14.6992 5.54688 14.6992H15.1469L15.2486 14.6924C15.6147 14.6427 15.8969 14.3289 15.8969 13.9492ZM15.1469 18C15.5611 18 15.8969 18.3358 15.8969 18.75C15.8969 19.1297 15.6147 19.4435 15.2486 19.4932L15.1469 19.5H5.54688C5.13266 19.5 4.79688 19.1642 4.79688 18.75C4.79688 18.3703 5.07903 18.0565 5.4451 18.0068L5.54688 18H15.1469ZM8.69687 9.14844C8.69687 8.73422 8.36109 8.39844 7.94688 8.39844H5.54688L5.4451 8.40528C5.07903 8.45495 4.79688 8.76874 4.79688 9.14844C4.79688 9.56265 5.13266 9.89844 5.54688 9.89844H7.94688L8.04865 9.89159C8.41472 9.84193 8.69687 9.52813 8.69687 9.14844Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.7bae78f8655445560f666bfb7df51f84.svg";
export { ForwardRef as ReactComponent };